import { useEffect } from 'react';
import { useChat } from './ChatContext';
import ChatButton from './ChatButton';
import ChatWindow from './ChatWindow';
import { getContextualGreeting } from './chatHelpers.jsx';

const ChatWidget = ({ userName = '', pageContext = 'default', enabled = true }) => {
  // Always call hooks unconditionally to maintain hook order
  const { isOpen, messages, addMessage } = useChat();

  // Initialize with greeting when chat opens
  useEffect(() => {
    if (isOpen && messages.length === 0) {
      setTimeout(() => {
        const greeting = getContextualGreeting(pageContext, userName);
        addMessage(greeting, 'ai');
      }, 500);
    }
  }, [isOpen, pageContext, userName, messages.length, addMessage]);

  // Conditionally render content, but hooks are always called
  if (!enabled) {
    return null;
  }

  return (
    <>
      <ChatButton />
      <ChatWindow pageContext={pageContext} />
    </>
  );
};

export default ChatWidget;

